import { Phone, FileText } from "lucide-react";
import { useQuote } from "./Cta";
import { BUSINESS } from "@/content/site";

export const MobileBar = () => {
  const quote = useQuote();
  return (
    <div data-testid="mobile-sticky-bar" className="fixed inset-x-0 bottom-0 z-50 md:hidden border-t border-amber-500/20 bg-[#08090a]/90 backdrop-blur-xl px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <div className="grid grid-cols-2 gap-2.5">
        <a href={BUSINESS.phoneHref} data-testid="mobile-sticky-call-btn"
          className="flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 py-3.5 text-xs font-semibold uppercase tracking-[0.14em] text-white">
          <Phone className="h-4 w-4 text-amber-400" /> Call Now
        </a>
        <button type="button" onClick={() => quote()} data-testid="mobile-sticky-quote-btn"
          className="flex items-center justify-center gap-2 rounded-full bg-amber-400 py-3.5 text-xs font-bold uppercase tracking-[0.14em] text-black">
          <FileText className="h-4 w-4" /> Free Quote
        </button>
      </div>
    </div>
  );
};
